<template>
    <div class="DashboardAlertList">
        <Alert v-for="(config, i) in configs" :key="i" :type="config.type">
            <div>
                <FontAwesomeIcon v-if="getIcon(config.type)" :icon="getIcon(config.type)" />
                {{ config.title }}
            </div>
            <ul v-if="config.details && config.details.length > 0" class="DashboardAlertList__details">
                <li v-for="detail in config.details" :key="detail">
                    {{ detail }}
                </li>
            </ul>
        </Alert>
    </div>
</template>
<style lang="scss">
    .DashboardAlertList__details {
        margin: 4px 0 0;
        padding-left: 20px;
    }
</style>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faCheckCircle, faExclamationTriangle, IconDefinition } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { Alert } from '@evidentid/dashboard-commons/components/Alert';
    import { AlertType } from '@evidentid/dashboard-commons/components/Alert/types';

    import { DashboardAlertConfig } from '@/modules/dashboard/types';

    export default defineComponent({
        name: 'DashboardAlertList',
        components: {
            Alert,
            FontAwesomeIcon,
        },
        props: {
            configs: {
                type: Array as PropType<DashboardAlertConfig[]>,
                default: (): DashboardAlertConfig[] => ([]),
            },
        },
        data() {
            return {
                faCheckCircle,
                faExclamationTriangle,
            };
        },
        methods: {
            getIcon(type: AlertType): IconDefinition | null {
                if (type === 'success') {
                    return this.faCheckCircle;
                } else if ([ 'warning', 'highWarning', 'danger' ].includes(type)) {
                    return this.faExclamationTriangle;
                } else {
                    return null;
                }
            },
        },
    });
</script>
